import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";

export const AssistantSheet = ({ open, onOpenChange }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="bottom" className="hud-sheet assistant-sheet" closeTestId="assistant-close-button" data-testid="assistant-sheet">
      <div className="sheet-grab" aria-hidden="true" />
      <SheetHeader><SheetTitle className="sheet-title" data-testid="assistant-sheet-title">LUCHADOR</SheetTitle></SheetHeader>
      <div className="assistant-empty" data-testid="assistant-empty-state"><span className="assistant-orb" aria-hidden="true" /><p>Nessuna conversazione.</p></div>
    </SheetContent>
  </Sheet>
);